import { useId } from 'react';
export default function WorkspaceTabs<T extends string>({ label, items, value, onChange }: {
  label: string; items: readonly { value: T; label: string }[]; value: T; onChange: (value: T) => void;
}) {
  const id = useId();
  return <div className="tk-tabs" role="tablist" aria-label={label}>{items.map((item, index) =>
    <button key={item.value} id={`${id}-${item.value}`} type="button" role="tab" tabIndex={value === item.value ? 0 : -1} aria-selected={value === item.value}
      onClick={() => onChange(item.value)} onKeyDown={event => {
        const next = event.key === 'ArrowRight' ? (index + 1) % items.length : event.key === 'ArrowLeft' ? (index + items.length - 1) % items.length : event.key === 'Home' ? 0 : event.key === 'End' ? items.length - 1 : null;
        if (next != null) { event.preventDefault(); onChange(items[next].value); document.getElementById(`${id}-${items[next].value}`)?.focus(); }
      }}>{item.label}</button>)}</div>;
}
